const AUTO_ADVANCE_MS = 3000;

const initHowItWorks = () => {
    const sections = document.querySelectorAll("[data-how-it-works]");
    if (!sections.length) {
        return;
    }

    const prefersReducedMotion = () =>
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    sections.forEach((section) => {
        const triggers = [...section.querySelectorAll("[data-how-trigger]")];
        const panels = [...section.querySelectorAll("[data-how-panel]")];
        const stepsEl = section.querySelector("[data-how-steps]");

        if (!triggers.length || !panels.length) {
            return;
        }

        const stepKeys = triggers.map((t) => t.dataset.howTrigger);

        const setActive = (stepKey) => {
            triggers.forEach((trigger) => {
                const isActive = trigger.dataset.howTrigger === stepKey;
                trigger.classList.toggle("is-active", isActive);
                trigger.setAttribute("aria-selected", isActive ? "true" : "false");
                trigger.setAttribute("tabindex", isActive ? "0" : "-1");
            });

            panels.forEach((panel) => {
                const isActive = panel.dataset.howPanel === stepKey;
                panel.classList.toggle("is-active", isActive);
                panel.setAttribute("aria-hidden", isActive ? "false" : "true");
            });
        };

        let intervalId = null;
        let isInView = false;
        let hasEnteredView = false;
        let hoverPaused = false;

        const clearAuto = () => {
            if (intervalId !== null) {
                clearInterval(intervalId);
                intervalId = null;
            }
        };

        const advance = () => {
            const active = triggers.find((t) => t.classList.contains("is-active"));
            const idx = active ? stepKeys.indexOf(active.dataset.howTrigger) : 0;
            const next = (idx >= 0 ? idx + 1 : 0) % stepKeys.length;
            setActive(stepKeys[next]);
        };

        const startAuto = () => {
            clearAuto();
            if (!isInView || hoverPaused || prefersReducedMotion() || !hasEnteredView) {
                return;
            }
            intervalId = window.setInterval(advance, AUTO_ADVANCE_MS);
        };

        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                isInView = entry.isIntersecting;
                if (isInView) {
                    hasEnteredView = true;
                    startAuto();
                } else {
                    clearAuto();
                    hoverPaused = false;
                }
            },
            { threshold: 0.15, rootMargin: "0px 0px -5% 0px" }
        );
        observer.observe(section);

        triggers.forEach((trigger) => {
            trigger.addEventListener("mouseenter", () => {
                hoverPaused = true;
                clearAuto();
                setActive(trigger.dataset.howTrigger);
            });
        });

        stepsEl?.addEventListener("mouseleave", () => {
            hoverPaused = false;
            startAuto();
        });

        triggers.forEach((trigger) => {
            trigger.addEventListener("click", () => {
                setActive(trigger.dataset.howTrigger);
            });
        });

        setActive(triggers[0].dataset.howTrigger);
    });
};

export default initHowItWorks;
